// Useful utils

const axios = require('axios');

/**
 * Checks if the object property is empty or not.
 *
 * @param {Object} data
 * @param {string} property
 *
 * @returns {boolean}
 */
function emptyObjectProperty(data, property) {
    if (!data.hasOwnProperty(property)) {
        return true;
    }
    if (data[property] === undefined) {
        return true;
    }
    if (data[property] === null) {
        return true;
    }
    if (typeof data[property] === "string" && data[property].trim() === "") {
        return true;
    }
    if (typeof data[property] === "number" && data[property] === 0) {
        return true;
    }
    if (typeof data[property] === "object" && data[property].length === 0) {
        return true;
    }
    return false;
};

/**
 * Checks if a variable is empty
 *
 * @param data
 *
 * @returns {boolean}
 */
function emptyVariable(data) {
    if (data === undefined) {
        return true;
    }
    if (data === null) {
        return true;
    }
    if (typeof data === "string" && data.trim() === "") {
        return true;
    }
    if (typeof data === "number" && data === 0) {
        return true;
    }
    if (typeof data === "object" && data.length === 0) {
        return true;
    }
    return false;
};

/**
 * Generates GUID
 *
 * @returns {string}
 */
function generateGuid() {
    // @FIXME: Do we need 4 and y in this string?
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

/**
 * Split array onto chunks of fixed size (last one can be smaller)
 * @param {array} arr
 * @param {number} chunkSize
 * @returns {array} an array of chunks
 */
function chunk(arr, chunkSize) {
    let idx = 0;
    const length = arr.length
    const result = []
    do {
        const chunk = arr.slice(idx, idx + chunkSize)
        if (chunk.length > 0) {
            result.push(chunk)
        }
        idx += chunkSize
    } while (idx <= length)
    return result
}

/**
 * Split an array into two arrays by a predicate
 * @param {Array<any>} arr
 * @param {any => boolean} predicate
 * @param {Array<Array<any>>} array of two arrays. First one contains elements matching the predicate
 */
function partition(arr, predicate) {
    const matching = []
    const notMatching = []
    arr.forEach(i => (predicate(i) ? matching : notMatching).push(i))
    return [matching, notMatching]
}

/**
 * Poll a resource by URL until it becomes available (HTTP status != 404)
 * @param {string} url a resource URL
 * @returns {Promise<string>}
 */
function waitUntilAvailable(url) {
    // The thumbnail URLs are signed S3 URLs. Because the signature is specific to the GET verb
    // we cannot use HEAD requests. Hence, requesting 0 bytes of the body using the `Range` header
    // https://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-query-string-auth.html
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Range_requests
    return axios.get(url, { headers: { 'Range' : 'bytes=0-0' } })
        .catch(error => {
            if (error.response && error.response.status === 404) {
                return delay(1000).then(() => waitUntilAvailable(url));
            } else {
                throw error
            }
        })
}

/**
 * Resolve the promise after certain time
 * @param {number} ms milliseconds
 * @returns {Promise}
 */
function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}

module.exports = { emptyObjectProperty, emptyVariable, generateGuid, chunk, partition, waitUntilAvailable, delay }
